import React, { createContext, useContext } from 'react';

type ImpressionWatcherContextProps = {
  stopPropagation?: boolean;
};

const ImpressionWatcherContext = createContext<ImpressionWatcherContextProps>({
  stopPropagation: false,
});

export const ImpressionWatcherProvider: React.FC<
  React.PropsWithChildren<ImpressionWatcherContextProps>
> = ({ children, stopPropagation }) => {
  return (
    <ImpressionWatcherContext.Provider value={{ stopPropagation }}>
      {children}
    </ImpressionWatcherContext.Provider>
  );
};

export const useImpressionWatcherContext = () =>
  useContext(ImpressionWatcherContext);

export default ImpressionWatcherContext;
